import { CardActionArea } from "@mui/material";
import { useHistory } from "react-router-dom";

import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH } from "../../ShiftDiscovery/paths";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { VisitCardContent } from "../Card/Content";
import { type PatientData, type VisitWithCaseData } from "../types";

interface InHomeOpenVisitCardProps {
  visit: VisitWithCaseData;
  patient: PatientData | undefined;
  specialties: string[];
  workplaceName: string;
}

export function InHomeOpenVisitCard(props: InHomeOpenVisitCardProps) {
  const { visit, patient, specialties, workplaceName } = props;
  const history = useHistory();
  const { generateModalPath } = useInHomeVisitModalsDataContext();

  return (
    <ShiftCardWrapper>
      <CardActionArea
        sx={{ flexGrow: 1 }}
        onClick={() => {
          history.push(
            generateModalPath(SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH, {
              visitId: visit.id,
              caseId: visit.attributes.caseId,
            })
          );
        }}
      >
        <VisitCardContent
          visit={visit}
          patient={patient}
          specialties={specialties}
          workplaceName={workplaceName}
        />
      </CardActionArea>
    </ShiftCardWrapper>
  );
}
